import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import PageNotFound from '@/views/PageNotFound'

Vue.use(Router)

export default new Router({
  mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    { path: "*", component: PageNotFound }
  ]
})
